import {formatCurrency} from "~/utils";
import '../style/ProductItem.css';

const ProductItem = ({product, onAdd, appData}) => {
    return (
        <div className="pos-product-item" onClick={() => onAdd(product)}>
            <div className="pos-product-info">
                <h4 className="pos-product-title">{product.title}</h4>
                <div className={'d-flex'} style={{gap:'5px'}}>
                    <span className="pos-product-code">{product.code}</span>
                    {product.attribute_label && (
                        <span className="pos-product-attribute">{product.attribute_label}</span>
                    )}
                </div>
            </div>
            <div className="pos-product-details">
                <div className="pos-product-price">
                    <span className="price-label">Giá:</span>
                    <span className="price-value">
                        {formatCurrency(product.price)}/ <span className={`stock-value ${product.unit === 'kg' ? 'out-of-stock' : ''}`}>
                        {product.unit === 'kg' ? '0.1 kg' : appData['units'][product.unit]?.label }
                    </span>
                    </span>
                </div>
                {product.vat > 0 && (
                    <div className="pos-product-vat">
                        <span className="vat-label">Thuế:</span>
                        <span className="vat-value">{product.vat}%</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductItem;
